/**
 *
 * IBM Confidential
 *
 * (C) Copyright IBM Corp. 2024
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U. S. Copyright Office
 *
 * US Government Users Restricted Rights - Use, duplication or
 * disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 *
 **/
import { defineMessages } from 'react-intl';

export const DialogNotificationMessages = defineMessages({
  notificationTitile: {
    id: 'actions.components.web-preview.DialogNotification.notificationTitle',
    defaultMessage: 'Dialog is active'
  },
  notificationSubtitile: {
    id: 'actions.components.web-preview.DialogNotification.notificationSubtitile',
    defaultMessage:
      'When Dialog is active, the dialog steps have precedence over Action steps. To deactivate Dialog, go to <a>Assistant settings.</a>'
  },
  goToSetting: {
    id: 'actions.components.web-preview.DialogNotification.goToSetting',
    defaultMessage: 'Go to settings'
  },
  dontRemindMe: {
    id: 'actions.components.web-preview.DialogNotification.dontRemindMe',
    defaultMessage: "Don't remind me"
  }
});
